import { StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import { heightPercentageToDP, isPhone } from 'utils/responsiveness';

import { ImageSize } from 'components/NagraImage/types';

const styles = StyleSheet.create({
    container: {
        marginRight: isPhone ? 32 : 16,
        marginBottom: heightPercentageToDP(8),
    },
    addProfileContainer: {
        width: ImageSize.PROFILE_IMAGE.width,
        height: ImageSize.PROFILE_IMAGE.width,
        borderRadius: ImageSize.PROFILE_IMAGE.width,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: heightPercentageToDP(4),
    },
    selectedIcon: {
        position: 'absolute',
        bottom: 10,
        right: 0,
    },
    textNameWrapper: {
        alignSelf: 'center',
        width: isPhone ? 104 : 132,
        maxWidth: isPhone ? 104 : 132,
    },
});

export default styles;
